import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DarkNavbar.css";

export default function DarkNavbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = ["home", "services", "api", "solutions", "about", "partners", "contact"];
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "Home", id: "home" },
    { name: "Services", id: "services" },
    { name: "APIs", id: "api" },
    { name: "Solutions", id: "solutions" },
    { name: "About", id: "about" },
    { name: "Partners", id: "partners" },
    { name: "Contact", id: "contact" }
  ];

  return (
    <nav className={`premium-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="navbar-content">
          
          <a className="navbar-logo" href="#home">
            <img src="/logo.png" alt="360 Gaming Labs" className="logo-image" />
          </a>

          <button
            className={`navbar-toggle ${open ? "active" : ""}`}
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`navbar-menu ${open ? "active" : ""}`}>
            <ul className="nav-list">
              {navItems.map((item) => (
                <li key={item.id} className="nav-list-item">
                  <a 
                    className={`nav-list-link ${activeSection === item.id ? "active" : ""}`}
                    href={`#${item.id}`}
                    onClick={() => setOpen(false)}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </nav>
  );
}
